import React, { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import api from "@/lib/api";

export default function AdminAudit() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/audit").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-audit">
      <h1 className="font-display text-3xl font-light sm:text-4xl">{t("admin.auditTitle")}</h1>
      <div className="mt-6 overflow-x-auto border border-border bg-surface">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="bg-muted text-left">
            <tr>
              <th className="p-3 font-medium">{t("admin.auditDate")}</th>
              <th className="p-3 font-medium">{t("admin.auditActor")}</th>
              <th className="p-3 font-medium">{t("admin.auditAction")}</th>
              <th className="p-3 font-medium">{t("admin.auditEntity")}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.id} data-testid={`audit-row-${row.id}`} className="border-t border-border">
                <td className="p-3 text-muted-foreground">{(row.created_at || "").slice(0, 19).replace("T", " ")}</td>
                <td className="p-3">{row.actor_email || "public"}<div className="text-xs text-muted-foreground">{row.actor_role || "—"}</div></td>
                <td className="p-3">{row.action}</td>
                <td className="p-3 text-muted-foreground">
                  {row.entity_type}
                  <div className="text-xs">{row.entity_id}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
